import { useQuery } from '@tanstack/react-query';
import { getSellerPayoutSchedules } from '@util/firestore/orders';

export function useSellerPayoutSchedules({
  orderId,
  productIds,
  enabled = true,
}: {
  orderId?: string;
  productIds: string[];
  enabled?: boolean;
}) {
  const sortedProductIds = [...productIds].sort();

  return useQuery({
    queryKey: ['seller-payout-schedules', orderId, sortedProductIds],
    queryFn: () =>
      getSellerPayoutSchedules(
        sortedProductIds.map((product_id) => ({
          order_id: orderId!,
          product_id,
        }))
      ),
    enabled: enabled && !!orderId && sortedProductIds.length > 0,
    staleTime: 60_000,
  });
}
